import React, { useState } from "react";
import { Box, Image, Button, Input, Text } from "@chakra-ui/react";
import axios from "axios";

export default function MediaUploader({
  value,
  onChange,
  maxSize = 5 * 1024 * 1024,
}) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > maxSize) {
      setError(`File too large (max ${Math.round(maxSize / 1024 / 1024)}MB)`);
      return;
    }
    setError(null);
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await axios.post("/api/v1/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data && res.data.publicUrl) {
        onChange && onChange(res.data.publicUrl);
      }
    } catch (e) {
      console.error(e);
      setError("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      {value && (
        <Box mb={2}>
          <Image src={value} maxH="120px" alt="preview" />
        </Box>
      )}
      <Input type="file" accept="image/*" onChange={handleFile} />
      {uploading && (
        <Text fontSize="12px" color="gray.500">
          Uploading…
        </Text>
      )}
      {error && (
        <Text fontSize="12px" color="red.500">
          {error}
        </Text>
      )}
    </Box>
  );
}
